import VariableNameCell from "./VariableNameCell";

export default VariableNameCell;
